import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import store from './stateManagement/store';
import { getAllAccessibleRoutes, getPortalRoleConfig } from './services/uiConfigService';
import useShortcutKeys from './components/dms_common/ShortcutKeys';

export const useGlobalShortcuts = () => {
  const navigate = useNavigate();

  const { ctrlKey } = useShortcutKeys();

  useEffect(() => {
    const handleKeyDown = async (event: KeyboardEvent) => {
      const isModifierPressed = ctrlKey === '⌘' ? event.metaKey : event.ctrlKey;

      if (isModifierPressed) {
        const shortcutMap: Record<string, string> = {
          g: '/dashboard/purchase/grn',
          o: '/dashboard/sale/manageOrders',
          i: '/dashboard/sale/manageInvoices',
          s: '/dashboard/stocks/realTimeStocks',
          l: '/dashboard/delivery/loadouts',
          d: '/dashboard/manageLoadout',
          r: '/dashboard/claims/status',
          m: '/dashboard/mdm2',
        };

        const key = event.key.toLowerCase();
        const targetRoute = shortcutMap[key];

        if (!targetRoute) return;

        event.preventDefault();

        let portalConfig = store.getState().portalConfigState;
        if (!portalConfig) {
          portalConfig = await getPortalRoleConfig();
        }

        const { featureConfig } = portalConfig;
        const accessibleRoutes: string[] = getAllAccessibleRoutes(featureConfig);
        const isAllowed = accessibleRoutes.includes(targetRoute);

        if (isAllowed) {
          navigate(targetRoute);
        } else {
          console.warn(`Access denied to: ${targetRoute}`);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);
};